import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import {request, handleRequestErrors} from '../../helpers/Requests'

class OrganisationName extends Component {
  render() {
    const { organisation, loaded, error, unauthorized } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/> 
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      localStorage.setItem('organisationName', organisation.name);

      return (
        <div>
          {organisation.name}
        </div>
      );
    }
  }

  state = {
    organisation: [],
    loaded: false,
    error: null,
    unauthorized: null
  };

  componentDidMount() {
    request("GET",`/v1/a/organisations/0`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        localStorage.setItem('organisationName', data.name);
        localStorage.setItem('enrolmentCode', data.enrolment_code);
        this.setState({ organisation: data, loaded: true })
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default OrganisationName;
